import React from 'react';
import { Col, Container, Row, Form, Button } from 'react-bootstrap';

import './buycoin_styles/buydisclaimer.css';

export default function BuyDisclaimer() {
  return (
    <>
      <Container className='mt-5 mb-5'>
        <Row>
          <Col>
            <div className="disclaimer">
              <div className="dis_upper">
                <h5 className='text-center'>DISCLAIMER</h5>
                <span>
                  You will leave SuperEx and go to <a href="http://" target="_blank">https://checkout.benxa.com/.</a> 
                   This purchase service is provided by Benxa, a third party organization. Please read the Banxa terms
                  of service carefully before purchasing terms of service. If you have any questions during the purchase
                  process you can contact Banxa Customer Services at support.banxa.com.
                </span>
              </div>
              <Form className='col-lg-4 col-md-6 col-sm-8 col-12 px-3 mx-auto'>
                <Form.Check 
                label= 'I have read and agree to the disclaimer'
                className='p-1 dis_inp'
                />
              </Form>
              <div className="dis_btn">
                <Button className='w-100'>PLACE YOUR ORDER NOW</Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}
